/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Mar 09 2021
 *  File : index.jsx
 *******************************************/
import TransactionTable from './TransactionTable';
export default TransactionTable;